import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireAuth = true, allowedRoles = [] }) {
  const { currentUser, userRole } = useAuth();

  // If authentication is required but user is not logged in
  if (requireAuth && !currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If user is logged in but doesn't have the required role
  if (requireAuth && allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // If user is logged in but trying to access auth pages (login/register)
  if (!requireAuth && currentUser) {
    // Redirect based on role
    if (userRole === 'admin') {
      return <Navigate to="/admin-dashboard" replace />;
    } else {
      return <Navigate to="/home" replace />;
    }
  }

  // Allow access to public routes (home, shop, product details) for everyone
  return children;
}
